"use strict"; // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

var _slicedToArray = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/chengluyu/Developer/anichart-marker/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

var common_1 = require("../../common");

var Prototypes = require("../../prototypes");

var coordinate_system_1 = require("../coordinate_system");

var elements_1 = require("../elements");

function facetRows(rows, indices, columns) {
  if (columns == null) {
    return [indices];
  } else {
    var facets = new common_1.MultistringHashMap();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      var _loop = function _loop() {
        var index = _step.value;
        var row = rows[index];
        var facetValues = columns.map(function (c) {
          return row[c];
        });

        if (facets.has(facetValues)) {
          facets.get(facetValues).push(index);
        } else {
          facets.set(facetValues, [index]);
        }
      };

      for (var _iterator = indices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        _loop();
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return Array.from(facets.values());
  }
}

exports.facetRows = facetRows;

var ChartRenderer =
/*#__PURE__*/
function () {
  function ChartRenderer(manager) {
    _classCallCheck(this, ChartRenderer);

    this.manager = manager;
  }
  /**
   * Render marks in a glyph
   * @returns an array of groups with the same size as glyph.marks
   */


  _createClass(ChartRenderer, [{
    key: "renderGlyphMarks",
    value: function renderGlyphMarks(plotSegment, plotSegmentState, coordinateSystem, offset, glyph, state, index) {
      var _this = this;

      return common_1.zipArray(glyph.marks, state.marks).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            mark = _ref2[0],
            markState = _ref2[1];

        if (!mark.properties.visible) {
          return null;
        }

        var g = _this.manager.getMarkClass(markState).getGraphics(coordinateSystem, offset, index, _this.manager, state.emphasized);

        var markClass = _this.manager.getMarkClass(markState);

        var type = markClass.object.properties.shape || markClass.object.classID.split(".")[1];

        if (g != null) {
          g.selectable = {
            plotSegment: plotSegment,
            glyphIndex: index,
            rowIndices: plotSegmentState.dataRowIndices[index]
          };

          if (type !== "text") {
            if (g.selectable.rowIndices.length == 1) {
              g["data-datum"] = JSON.stringify(Object.assign({
                _TYPE: type,
                _MARKID: markClass.object.properties.name,
                _x: coordinateSystem.getBaseTransform().x + offset.x,
                _y: coordinateSystem.getBaseTransform().y + offset.y
              }, _this.manager.dataset.tables[0].rows[g.selectable.rowIndices[0]]));
            } else {
              g["data-datum"] = JSON.stringify(g.selectable.rowIndices.map(function (i) {
                return Object.assign({
                  _TYPE: type,
                  _MARKID: markClass.object.properties.name,
                  _x: coordinateSystem.getBaseTransform().x + offset.x,
                  _y: coordinateSystem.getBaseTransform().y + offset.y
                }, _this.manager.dataset.tables[0].rows[i]);
              }));
            }
          }

          return elements_1.makeGroup([g]);
        } else {
          return null;
        }
      });
    }
  }, {
    key: "renderChart",
    value: function renderChart(dataset, chart, chartState) {
      var graphics = []; // Chart background

      var bg = this.manager.getChartClass(chartState).getBackgroundGraphics();

      if (bg) {
        graphics.push(bg);
      }

      var linkGroup = elements_1.makeGroup([]);
      graphics.push(linkGroup);
      var elementsAndStates = common_1.zipArray(chart.elements, chartState.elements); // Render layout graphics

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = elementsAndStates[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref5 = _step2.value;

          var _ref4 = _slicedToArray(_ref5, 2);

          var element = _ref4[0];
          var elementState = _ref4[1];

          if (!element.properties.visible) {
            continue;
          } // Render marks if this is a plot segment


          if (Prototypes.isType(element.classID, "plot-segment")) {
            var plotSegment = element;
            var plotSegmentState = elementState;
            var mark = common_1.getById(chart.glyphs, plotSegment.glyph);
            var plotSegmentClass = this.manager.getPlotSegmentClass(plotSegmentState);
            var coordinateSystem = plotSegmentClass.getCoordinateSystem(); // Render glyphs

            var glyphArrays = [];
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
              for (var _iterator3 = plotSegmentState.glyphs.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var _ref8 = _step3.value;

                var _ref7 = _slicedToArray(_ref8, 2);

                var glyphIndex = _ref7[0];
                var glyphState = _ref7[1];
                var anchorX = glyphState.marks[0].attributes.x;
                var anchorY = glyphState.marks[0].attributes.y;
                var offsetX = glyphState.attributes.x - anchorX;
                var offsetY = glyphState.attributes.y - anchorY;

                var _g = this.renderGlyphMarks(plotSegment, plotSegmentState, coordinateSystem, {
                  x: offsetX,
                  y: offsetY
                }, mark, glyphState, glyphIndex);

                glyphArrays.push(_g);
              } // Transpose glyphArrays so each mark is in a layer

            } catch (err) {
              _didIteratorError3 = true;
              _iteratorError3 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }
              } finally {
                if (_didIteratorError3) {
                  throw _iteratorError3;
                }
              }
            }

            var glyphElements = common_1.transpose(glyphArrays).map(function (x) {
              return elements_1.makeGroup(x);
            });
            var gGlyphs = elements_1.makeGroup(glyphElements);
            gGlyphs.transform = coordinateSystem.getBaseTransform();
            var gElement = elements_1.makeGroup([]);
            var g = plotSegmentClass.getPlotSegmentGraphics(gGlyphs, this.manager);
            gElement.elements.push(g);
            gElement.key = element._id;
            graphics.push(gElement);
          } else if (Prototypes.isType(element.classID, "mark")) {
            var cs = new coordinate_system_1.CartesianCoordinates({
              x: 0,
              y: 0
            });

            var _gElement = elements_1.makeGroup([]);

            var elementClass = this.manager.getMarkClass(elementState);

            var _g2 = elementClass.getGraphics(cs, {
              x: 0,
              y: 0
            }, null, this.manager);

            _gElement.elements.push(_g2);

            _gElement.key = element._id;
            graphics.push(_gElement);
          } else {
            var _gElement2 = elements_1.makeGroup([]);

            var _elementClass = this.manager.getChartElementClass(elementState);

            var _g3 = _elementClass.getGraphics(this.manager);

            _gElement2.elements.push(_g3);

            _gElement2.key = element._id;
            graphics.push(_gElement2);
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return elements_1.makeGroup(graphics);
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderChart(this.manager.dataset, this.manager.chart, this.manager.chartState);
    }
  }]);

  return ChartRenderer;
}();

exports.ChartRenderer = ChartRenderer;

__export(require("./text_measurer"));